<div class="shear-inner">
  <div class="news-entry inner-content">
    <h1>
      @if (isDetail()) {
        {{ newsEntry().title }}
      } @else {
        <a [routerLink]="['/news', newsEntry().id]" [queryParams]="{title: prepareForQueryParameter(newsEntry().title)}">
          {{ newsEntry().title }}
        </a>
      }
    </h1>
    <div>
      <span>{{ newsEntry().createdAt | date:'fullDate' }}</span>&nbsp;
      <span i18n>durch <a class="filter" href="javascript:void(0)" (click)="filterByAuthor(newsEntry().author)">{{ newsEntry().author.fullName }}</a></span>&nbsp;
      <span i18n>gespeichert in</span>&nbsp;
      @for (tag of newsEntry().tags; track tag.id) {
        <a class="filter" (click)="filterByTag(tag)" href="javascript:void(0)">{{ tag.name }}</a>
        @if (!$last) {
          &nbsp;|&nbsp;
        }
      }
    </div>
    <div>
      <span [innerHTML]="getContentHtml(newsEntry().content.html, !isDetail()) | safeHtml"></span>
      @if (!isDetail()) {
        <a class="lh-lg"
           [routerLink]="['/news', newsEntry().id]"
           [queryParams]="{title: prepareForQueryParameter(newsEntry().title)}"
           i18n>
          Mehr lesen&hellip;
        </a>
      }
    </div>
  </div>
</div>
